module.exports = __webpack_public_path__ + "img/enter_VC_icon.ff742af8.svg";